<template>
  <div class="editorial-nav-items">
    <NavBarItem title="Blog" link="/blog" />
    <NavBarItem title="Workshops" link="/workshops" />
    <NavBarItem title="Courses" link="/courses" />
    <NavBarItem title="Community" link="https://discord.com/invite/3MdvPfT" />
    <NavBarItem title="About" link="/about" data-testid="nav-about" />
  </div>
</template>
